import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlanksComponent } from './blanks.component';
import { IndexComponent } from './pages/index/index.component';

const routes: Routes = [
  {
    path: '',
    component: BlanksComponent,
    children: [
      {
        path: '',
        component: IndexComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlanksRoutingModule {}
